var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"mt-6 mb-8 text-center body-1",domProps:{"innerHTML":_vm._s(_vm.$t('welcome.company'))}}),_c('div',{staticClass:"w-full d-flex justify-center align-center"},[_c('BankIdLoginButton',{staticStyle:{"width":"100% !important"},attrs:{"button-text":_vm.$t('login.password.log-in')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }